import styled from "styled-components"

const SubFolderHeadingTitle = styled.div`
  cursor: pointer;
  color: var(--primaryVariant);
  margin-left: 0.5rem;
  font-size: var(--doc-font-size);
`
export default SubFolderHeadingTitle
